<template>
  <prona-wizard-step class="wizard-step-nims-order-overview" :proceed-disabled="true">
    <div>
      <h4 v-html="$t('pronatura.widget.nimswizard.confirmation.subtitle')"></h4>
    </div>
    <template #step-actions>
      <div></div>
    </template>
  </prona-wizard-step>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    name: 'WizardStepnimsOverview',
    props: {
    },
    data: () => ({
      isLoading: false,
      error: undefined as any,
    }),
  });
</script>
